import { index, sqliteTable, text, uniqueIndex } from "drizzle-orm/sqlite-core";
import { sql } from "drizzle-orm";
import { fiscalYears } from "./fiscal-years";
import { FINANCIAL_STATEMENT_ENTITY_PROFILES } from "./financial-statement-notes";

export const FINANCIAL_STATEMENT_PACK_STATUSES = [
  "draft",
  "review",
  "approved",
  "reopened",
  "voided",
] as const;

export const financialStatementPacks = sqliteTable("accounting_financial_statement_packs", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  fiscalYearId: text("fiscal_year_id").notNull().references(() => fiscalYears.id),
  packVersion: text("pack_version").notNull(),
  entityProfile: text("entity_profile", { enum: FINANCIAL_STATEMENT_ENTITY_PROFILES }).notNull().default("general"),
  periodFrom: text("period_from").notNull(),
  periodTo: text("period_to").notNull(),
  status: text("status", { enum: FINANCIAL_STATEMENT_PACK_STATUSES }).notNull().default("draft"),
  snapshotVersion: text("snapshot_version").notNull().default("1"),
  snapshotJson: text("snapshot_json"),
  validationJson: text("validation_json"),
  sourceIdsJson: text("source_ids_json"),
  supersedesPackId: text("supersedes_pack_id"),
  correctionReason: text("correction_reason"),
  reopenReason: text("reopen_reason"),
  reviewedAt: text("reviewed_at"),
  reviewedBy: text("reviewed_by"),
  approvedAt: text("approved_at"),
  approvedBy: text("approved_by"),
  reopenedAt: text("reopened_at"),
  reopenedBy: text("reopened_by"),
  voidedAt: text("voided_at"),
  voidedBy: text("voided_by"),
  voidReason: text("void_reason"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyStatusIdx: index("fsp_company_status_idx").on(table.companyId, table.status, table.periodTo),
  companyPeriodIdx: index("fsp_company_period_idx").on(table.companyId, table.periodFrom, table.periodTo),
  fiscalYearIdx: index("fsp_fiscal_year_idx").on(table.companyId, table.fiscalYearId),
  supersedesIdx: index("fsp_supersedes_idx").on(table.supersedesPackId),
  activeDraftReviewBranchIdx: uniqueIndex("fsp_active_draft_review_branch_idx")
    .on(table.companyId, table.branchId, table.fiscalYearId, table.packVersion)
    .where(sql`${table.status} IN ('draft', 'review') AND ${table.branchId} IS NOT NULL AND ${table.deletedAt} IS NULL`),
  activeDraftReviewCompanyIdx: uniqueIndex("fsp_active_draft_review_company_idx")
    .on(table.companyId, table.fiscalYearId, table.packVersion)
    .where(sql`${table.status} IN ('draft', 'review') AND ${table.branchId} IS NULL AND ${table.deletedAt} IS NULL`),
}));

export type FinancialStatementPack = typeof financialStatementPacks.$inferSelect;
export type NewFinancialStatementPack = typeof financialStatementPacks.$inferInsert;
export type FinancialStatementPackStatus = (typeof FINANCIAL_STATEMENT_PACK_STATUSES)[number];
